import React from 'react';

interface EditItemButtonProps {
  /** Rótulo acessível completo, ex.: "Editar destaque: Título da matéria". */
  label: string;
  onClick: () => void;
  className?: string;
}

/**
 * Lápis que abre um item específico na barra lateral.
 *
 * Só é renderizado dentro do editor (a `CapaView` pública nunca passa o
 * callback). Fica sempre FORA do `<a>` do card: o link cobre o card inteiro
 * com `after:absolute after:inset-0`, então este botão precisa ser um irmão
 * posterior com `z-10` para receber o clique. O `preventDefault` +
 * `stopPropagation` é cinto de segurança caso a estrutura do DOM mude.
 */
export const EditItemButton: React.FC<EditItemButtonProps> = ({
  label,
  onClick,
  className,
}) => (
  <button
    type="button"
    aria-label={label}
    title={label}
    onClick={(event) => {
      event.preventDefault();
      event.stopPropagation();
      onClick();
    }}
    className={`z-10 flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-full bg-black/60 text-white transition-colors hover:bg-black/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black/60 ${className ?? ''}`}
  >
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      className="h-4 w-4"
    >
      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
    </svg>
  </button>
);

export default EditItemButton;
